export type ChangeLogEntry = {
  authorEmail: string;
  authorUserId: string;
  changes: string[];
  comment: string;
  createdAt: number;
  feature: string;
  version: number;
};

export type Fraction = {
  percentageValue: number;
  value: string;
};

export type FractionalFlag = {
  currentVersion: number;
  feature: string;
  isFractional: boolean;
  notes?: string;
  settings: {
    globalFraction: number;
    orgIdFractions: Record<string, number>;
    projectIdFractions: Record<string, number>;
  };
};

export type NonFractionFlag = {
  currentVersion: number;
  feature: string;
  isFractional: boolean;
  notes?: string;
  settings: {
    disabledOrgIds: number[];
    disabledProjectIds: number[];
    enabledGlobally: boolean;
    enabledOrgIds: number[];
    enabledProjectIds: number[];
  };
};

export type FeatureFlag = FractionalFlag | NonFractionFlag;

export type ReducerState = {
  changeLog: ChangeLogEntry[];
  error?: Error;
  featureFlags: FeatureFlag[];
  fetching: boolean;
  fetchingChangeLog: boolean;
  users: UsersByOrganization[];
};

export type FeatureFlagState = {
  comment: string;
  disabledOrgIds: number[];
  disabledProjectIds: number[];
  enabledGlobally: boolean;
  enabledOrgIds: number[];
  enabledProjectIds: number[];
  isFractional: boolean;
  globalFraction: number;
  notes: string;
  orgIdFractions: { [id: string]: number };
  projectIdFractions: { [id: string]: number };
};

export enum Actions {
  Enabled = 'Enabled',
  Disabled = 'Disabled',
}

export enum Nouns {
  Org = 'org',
  Project = 'project',
}

export type UsersByOrganization = {
  email: string;
  orgName: string;
  orgId: number;
};
